<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
      <CCardBody>
      <form
      @submit="saveData"
      method="post"
      >
          <h3 v-if="isEditing">
            {{ $t('button.edit') }} {{ $t('clients.label') }}
          </h3>
          <h3 v-else>{{ $t('button.create') }} {{ $t('clients.label') }}</h3>
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.name')" type="text" placeholder="Ex: Juan Perez" v-model="client.name" required></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.address')" type="text" placeholder="Ex: 27 de Febrero" v-model="client.address" required></CInput>
            </div>
          </div>
          
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.address2')" type="text" placeholder="Ex: " v-model="client.address2" required></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.phone')" type="text" placeholder="Ex: 809-111-1111" v-model="client.phone" required></CInput>
            </div>
          </div>
          
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.phone2')" type="text" placeholder="Ex: 809-111-1111" v-model="client.phone2"></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.state')" type="text" placeholder="Ex: Distrito Nacional" v-model="client.state" required></CInput>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.city')" type="text" placeholder="Ex: Santo Domingo" v-model="client.city" required></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.zipcode')" type="text" placeholder="Ex: 11111" v-model="client.zipcode" required></CInput>
            </div>
          </div>
          
          <div class="row">
            <div class="col-6">
              <CSelect
                :label="$t('fields.order_frequency')"
                :value.sync="client.order_frequency"
                :plain="true"
                :options="frequency_days"
                :placeholder="$t('fields.days_placeholder')"
                required
              >
              </CSelect>
            </div>
            <div class="col-6">
              <CSelect
                :label="$t('fields.is_active')" 
                :value.sync="client.status"
                :plain="true"
                :options="statuses"
                :placeholder="$t('fields.status_placeholder')"
                required
              >
              </CSelect>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CSelect
                :label="$t('fields.payment_frequency')"
                :value.sync="client.frequency_payment"
                :plain="true"
                :options="frequency_payments"
                :placeholder="$t('fields.payment_frequency_placeholder')"
                required
              >
              </CSelect>
            </div>
            <div class="col-6">
              <CSelect
                :label="$t('fields.credit_frequency')"
                :value.sync="client.frequency_credit"
                :plain="true"
                :options="frequency_credits"
                :placeholder="$t('fields.credit_frequency_placeholder')"
              >
              </CSelect>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CSelect
                :label="$t('fields.client_type')"
                :value.sync="client.client_type"
                :plain="true"
                :options="client_types"
                :placeholder="$t('fields.client_type_placeholder')"
                required
              >
              </CSelect>
            </div>
            <div class="col-6">
                <br>
              <CInputCheckbox
                :label="$t('fields.check_frequency')"
                value="true"
                :checked.sync="client.frequency_active"
                @update:checked="frequencyCheck"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
                <CSelect
                    label="Water Dispenser"
                    :value.sync="client.water_dispenser"
                    :plain="true"
                    :options="water_dispenser"
                    placeholder="Select a Water Dispenser"
                    required
                >
                </CSelect>
            </div>
            <div class="col-6">
              <CInput label="Existing Bottles" type="text" placeholder="Ex: 100" v-model="client.existing_bottles" required></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
                <br>
              <CInputCheckbox
                  label="Own"
                  :checked.sync="client.own"
              />
            </div>
            <div class="col-3">
                <br>
              <CInputCheckbox
                  label="Rented"
                  :checked.sync="client.rented"
              />
                <br>
                <br>
            </div>
            <div class="col-6" v-if="client.own">
                <CInput label="Date" type="date" v-model="client.own_date" required></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CTextarea :label="$t('fields.comment')" :placeholder="$t('fields.comment_placeholder')" v-model="client.comment"></CTextarea>
            </div>
          </div>
          <CButton color="success" type="submit">
            <template v-if="isEditing"><CIcon :content="$options.updateIcon" /> {{ $t('button.update') }}</template>
            <template v-else><CIcon :content="$options.addIcon" /> {{ $t('button.create') }}</template>
            </CButton>
          <CButton color="primary" @click="goBack"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
          </form>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormClient',
  mixins: [formMixin, localeMixin],
  updateIcon: cilSync,
  addIcon: cilPlus,
  backIcon: cilArrowLeft,
  data() {
    return {
        client: {
          name: '',
          address: '',
          address2: '',
          phone: '',
          phone2: '',
          state: '',
          city: '',
          order_frequency: '',
          frequency_payment: '',
          frequency_credit: '',
          client_type: '',
          frequency_active: true,
          zipcode: '',
          comment: '',
          water_dispenser: '',
          own: false,
          rented: false,
          own_date: '',
          existing_bottles: '',
          status: ''
        },
        statuses: [
          {
            label: i18n.t('fields.active'),
            value: "1"
          },
          {
            label: i18n.t('fields.inactive'),
            value: "0"
          }
        ],
        water_dispenser: [
          {
            label: "Yes",
            value: 1
          },
          {
            label: "No",
            value: 0
          }
        ],
        frequency_days: [],
        frequency_payments: [
          {
            label: i18n.t('fields.card'),
            value: "card"
          },
          {
            label: i18n.t('fields.check'),
            value: "check"
          },
          {
            label: i18n.t('fields.cash'),
            value: "cash"
          }
        ],
        frequency_credits: [
          {
            label: i18n.t('fields.weekly'),
            value: "weekly"
          },
          {
            label: i18n.t('fields.biweekly'),
            value: "biweekly"
          },
          {
            label: i18n.t('fields.monthly'),
            value: "monthly"
          }
        ],
        client_types: [
          {
            label: "Regular",
            value: "regular"
          },
          {
            label: "Bodega",
            value: "bodega"
          }
        ]
    }
  },
  mounted() {
      this.fillDays();
      if (this.isEditing) {
        axios.get('/api/clients/' + this.$route.params.id + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
            const data = response.data;
            this.client = data;
            console.log(data);
            console.log(this.client);
            this.client.status_class = this.client.active ? "primary" : "secondary";
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
      }
  },
  methods: {
    goBack() {
        this.$router.push({ name: "Clients" });
    },
      showAlertError() {
          if (this.message != "") {
              this.$swal({
                  title: i18n.t('modal.error.title'),
                  text: this.message,
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          } else {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: i18n.t('modal.body'),
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          }
      },
    showAlert () {
      if (this.isEditing) {
        this.$swal(
          i18n.t('clients.modal.updated_label'),
          i18n.t('clients.modal.updated_body'),
          'success'
        ).then(result => {
          this.goBack();
        });
      } else {
        this.$swal(
          i18n.t('clients.modal.created_label'),
          i18n.t('clients.modal.created_body'),
          'success'
        ).then(result => {
          this.goBack();
        });
      }
    },
    saveData(e) {
        e.preventDefault();
        // const data = formData || this.prepareObjectData();
        const data = this.client;
        this.$emit("saved", data);
        let url = `/api/clients`;
        let sendRequest = null;

        if (this.isEditing) {
            url = url + "/" + this.$route.params.id + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.put(url, data);
                    if (response.data.status === "success") {
                        this.showAlert();
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlertError(); 
                    } else{
                        this.showAlertError(); 
                    }
                }
            };
        } else {
            url = url + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        this.showAlert();
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlertError(); 
                    } else{
                        console.log(error);
                        this.showAlertError(); 
                    }
                }
            };
        }
        sendRequest();
        return data;
    },
    fillDays() {
        const count_days = 90;
        for(let i = 1; i <= count_days; i++) {
            this.frequency_days.push({
                label: i,
                value: i
            });
        }
    },
    frequencyCheck() {
      console.log(this.client.frequency_active);
    }
  }
}

/*
      items: (id) => {
        const user = usersData.find( user => user.id.toString() === id)
        const userDetails = user ? Object.entries(user) : [['id', 'Not found']]
        return userDetails.map(([key, value]) => {return {key: key, value: value}})
      },
*/

</script>
